<div class="background" [ngClass]="{ landscape: rwdService.isPhoneLandscape }">
  <div class="logo" [ngClass]="{ portrait: rwdService.isPhonePortrait }">
    <img src="assets/fliko.svg" />
  </div>
  <div [ngSwitch]="mode" class="content-wrapper">
    <ng-container *ngSwitchCase="'resetPassword'">
      <ng-container *ngIf="done">
        <h1>{{ 'passwd.saved' | loc }}!</h1>
      </ng-container>
      <ng-container *ngIf="!done">
        <div class="header">
          <h1>{{ 'passwd.addNew' | loc }}:</h1>
          <app-language-select></app-language-select>
        </div>
        <form [formGroup]="form">
          <app-password-input labelKey="passwd.label" type="password" formControlName="password" [newPassword]="true">
          </app-password-input>
          <app-password-input labelKey="passwd.repeat" type="password" formControlName="confirm" [newPassword]="true">
          </app-password-input>

          <app-password-requirements passwordCtrName="password" confirmCtrName="confirm"></app-password-requirements>

          <label> {{ 'passwd.strength' | loc }}: </label>
          <password-strength-meter [password]="form.value.password" [minPasswordLength]="MIN_LENGTH"> </password-strength-meter>
          <button class="full-width" mat-stroked-button color="primary" (click)="setPassword()">
            {{ 'button.confirm' | loc }}
          </button>
        </form>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'verifyEmail'">
      <div class="flex-right">
        <app-language-select></app-language-select>
      </div>
      <h1>{{ (done ? 'account.activateSuccess' : 'account.activateWait') | loc }}</h1>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <div class="flex-right">
        <app-language-select></app-language-select>
      </div>
      <mat-error class="action-error">{{ 'error.' + error | loc }}</mat-error>
    </ng-container>
  </div>
  <div class="bottom-img" *ngIf="!rwdService.isPhoneLandscape">
    <img src="assets/images/news.svg" />
  </div>
</div>
